export default {
  panel: {
    title: 'Mise à jour',
    description:
      "Une nouvelle version de l'application est disponible. Voulez-vous la télécharger ?",
    downloadAppStore: 'Télécharger sur l’App Store',
    downloadPlayStore: 'Télécharger sur le Google Play Store',
  },
};
